/**
 * Sorcerer rule overrides.
 *
 * Card text (verbatim from sorcery-cards.json):
 *   "Tap → Draw a spell.
 *    Tap → Play or draw a site."
 *
 * The second line is the standard avatar ability (no override needed.
 * GameBoard wires it as a _builtin called `avatar_site`). The first
 * line is a second, INDEPENDENT tap ability. Each tap costs an action
 * so only one fires per turn, but the avatar surface needs to offer
 * both choices.
 *
 * v1.74. First avatar to use `extraActivatedAbilities`. Future
 * avatars that carry extra Tap abilities (e.g. Geomancer's second
 * Tap-replace-Rubble) hang their entries here too.
 */
export const SORCERER_RULES = {
  extraActivatedAbilities: [
    {
      id: '__builtin_tap_draw_spell',
      trigger: 'activated',
      cost: [{ type: 'tap' }],
      description: 'Draw a spell',
      _builtin: 'tap_draw_spell',
    },
  ],
};
